import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_TYPE, VkGoalEvent } from "../../constants";
import { vkPushEvent, ymPushEvent, ymPushParams, ymPushWithUrl } from "../../utils";
var CONVERGENT_TARIFF_CONNECT = 'ConvergentTariffConnect';
var getTextWithoutTags = function getTextWithoutTags(str) {
  return str.replace(/<[^>]+>/gm, ' ');
};
export var sendInfoCardClickAnalytics = function sendInfoCardClickAnalytics(pageType, cardName) {
  return ymPushParams(_defineProperty({}, pageType, {
    page_menu: getTextWithoutTags(cardName)
  }));
};
export var sendCheckAddressToTariffsAnalytics = function sendCheckAddressToTariffsAnalytics(pageType) {
  return ymPushParams(_defineProperty({}, pageType, {
    address_check: 'to_tariffs'
  }));
};
export var sendCheckAddressResultTextAnalytics = function sendCheckAddressResultTextAnalytics(_ref) {
  var isConvergent = _ref.isConvergent,
    pageType = _ref.pageType,
    checkingResult = _ref.checkingResult,
    addressData = _ref.addressData;
  var fullAddress = "".concat(checkingResult, ": ").concat(addressData === null || addressData === void 0 ? void 0 : addressData.city, ", ").concat(addressData === null || addressData === void 0 ? void 0 : addressData.street, ", ").concat(addressData === null || addressData === void 0 ? void 0 : addressData.house, ", ").concat(addressData === null || addressData === void 0 ? void 0 : addressData.flat);
  var addressParam = isConvergent ? 'map_address_check' : 'address_check';
  ymPushParams(_defineProperty({}, pageType, _defineProperty({}, addressParam, fullAddress)));
};
export var sendCheckAddressPhoneClickAnalytics = function sendCheckAddressPhoneClickAnalytics(pageType, isConvergent) {
  ymPushParams(_defineProperty({}, pageType, {
    phone_click: 'map'
  }));
  var keyName = isConvergent ? 'ConvergentPhoneClick' : 'HomeTariffPhoneClick';
  ymPushWithUrl(keyName);
};
export var sendLeavePhoneClickAnalytics = function sendLeavePhoneClickAnalytics(_ref2) {
  var isConvergent = _ref2.isConvergent,
    pageType = _ref2.pageType;
  if (isConvergent) {
    ymPushWithUrl('ConvergentPhoneClick');
  } else {
    ymPushParams(_defineProperty({}, pageType, {
      phone_click: 'banner'
    }));
    ymPushWithUrl('HomeTariffPhoneClick');
  }
};

// TODO: возможно неактуальная аналитика, уточнить
export var sendConnectionQuestionsPhoneClickAnalytics = function sendConnectionQuestionsPhoneClickAnalytics() {
  ymPushParams({
    fttb_page_ev_: {
      phone_click: 'call_back_form'
    }
  });
  ymPushEvent('HomeTariffPhoneClick');
};
export var sendTariffsTabsChangeTextAnalytics = function sendTariffsTabsChangeTextAnalytics(pageType, menuSection) {
  return ymPushParams(_defineProperty({}, pageType, {
    tariff_menu_click: menuSection
  }));
};
export var sendCallBackPhoneFillAnalytics = function sendCallBackPhoneFillAnalytics(pageType) {
  return ymPushParams(_defineProperty({}, pageType, 'call_back_form_fill'));
};
export var sendCallBackPhoneSubmitAnalytics = function sendCallBackPhoneSubmitAnalytics(pageType, isConvergent) {
  var keyName = isConvergent ? 'ConvergentTariffCallbackShortForm' : 'HomeTariffCallbackForm';
  ymPushParams(_defineProperty({}, pageType, 'call_back_form_submit'));
  ymPushWithUrl(keyName, {
    form_type: 'callback_form'
  });
  vkPushEvent(VkGoalEvent.shpdOrderedACall);
};
export var sendFAQTabClickAnalytics = function sendFAQTabClickAnalytics(pageType, faqTitle) {
  return ymPushParams(_defineProperty({}, pageType, {
    faq: {
      faq_click: faqTitle
    }
  }));
};
export var sendDeviceClickMoreAnalytics = function sendDeviceClickMoreAnalytics(pageType, deviceTitle) {
  return ymPushParams(_defineProperty({}, pageType, {
    device: {
      click: deviceTitle
    }
  }));
};
export var sendDeviceClickAddAnalytics = function sendDeviceClickAddAnalytics(pageType, deviceTitle) {
  return ymPushParams(_defineProperty({}, pageType, {
    device: {
      add: deviceTitle
    }
  }));
};
export var sendVkEventAnalytic = function sendVkEventAnalytic(pageType) {
  var goal = _defineProperty(_defineProperty({
    presetUp: VkGoalEvent.shpdTvIntOpenForm,
    homeInternetAndTv: VkGoalEvent.shpdTvOpenForm,
    homeInternet: VkGoalEvent.shpdOpenForm
  }, PAGE_TYPE.fttb_net, VkGoalEvent.shpdOpenForm), PAGE_TYPE.fttb_kit, VkGoalEvent.shpdTvOpenForm)[pageType];
  vkPushEvent(goal);
};
export var sendVkDetailsEventAnalytic = function sendVkDetailsEventAnalytic(pageType) {
  var goal = _defineProperty(_defineProperty({}, PAGE_TYPE.fttb_net, VkGoalEvent.shpdLead), PAGE_TYPE.fttb_kit, VkGoalEvent.shpdTvLead)[pageType];
  vkPushEvent(goal);
};
export var sendTariffsSectionClickAnalytics = function sendTariffsSectionClickAnalytics(_ref3) {
  var tariffTitle = _ref3.tariffTitle,
    group = _ref3.group,
    pageType = _ref3.pageType;
  sendVkEventAnalytic(group);
  if (group !== 'homeInternetTvAndMobile') return;
  ymPushParams(_defineProperty({}, pageType, {
    tariff_form_submit: tariffTitle
  }));
  ymPushEvent(CONVERGENT_TARIFF_CONNECT, {
    form: 'tariff_section',
    tariff: tariffTitle
  });
};
export var sendFloatingPhoneClickAnalytics = function sendFloatingPhoneClickAnalytics(isConvergent) {
  var keyName = isConvergent ? 'ConvergentTariffConnect' : 'HomeTariffConnect';
  ymPushEvent(keyName, {
    form_type: 'icon',
    URL: window.location.href
  });
  vkPushEvent(VkGoalEvent.shpdInitiateCallback);
};
export var sendAnalyticsOnBlockVisibility = function sendAnalyticsOnBlockVisibility(pageType, blockTitle) {
  var blockTitleWithoutTags = getTextWithoutTags(blockTitle);
  ymPushParams(_defineProperty({}, pageType, {
    view_screen: blockTitleWithoutTags
  }));
};
export var sendAnalyticsOnHeadingBannerClick = function sendAnalyticsOnHeadingBannerClick(_ref4) {
  var pageType = _ref4.pageType,
    bannerTitle = _ref4.bannerTitle,
    url = _ref4.url;
  ymPushParams(_defineProperty({}, pageType, {
    main_banner_click: _defineProperty({}, bannerTitle, url)
  }));
};
export var sendBlockBannerAnalytics = function sendBlockBannerAnalytics(_ref5) {
  var pageType = _ref5.pageType,
    event = _ref5.event,
    id = _ref5.id,
    name = _ref5.name,
    _ref5$url = _ref5.url,
    url = _ref5$url === void 0 ? 'pop_up' : _ref5$url;
  ymPushParams({
    banners_ev_: _defineProperty({}, event, _defineProperty({}, pageType, {
      position: _defineProperty({}, "carousel_".concat(id), _defineProperty({}, name, url))
    }))
  });
};
export var sendVkCheckAddressEventAnalytics = function sendVkCheckAddressEventAnalytics(connected) {
  var goal = connected ? VkGoalEvent.shpdInitiateAddress : VkGoalEvent.shpdInitiateNotAddress;
  vkPushEvent(goal);
};